const EMIT_EVENT = "EMIT_EVENT";
const EVENT_HANDLED = "EVENT_HANDLED";

export const EVENT_TYPES = {
    RENDER_PARTIALITIES_TABLE: 'RENDER_PARTIALITIES_TABLE',
    REMOVE_PARTIALITIES_TABLE: 'REMOVE_PARTIALITIES_TABLE',
};

function initialState() {
    return {
        event: null,
    };
}

const EventListener = {
    namespaced: true,

    state: initialState,

    mutations: {
        [EMIT_EVENT] (state, event) {
            state.event = event;
        }, 

        [EVENT_HANDLED] (state) {
            state.event = null;
        }
    },

    actions: {
        emit({ commit }, event) {
            commit(EMIT_EVENT, event)
        },

        eventHandled({ commit }) {
            commit(EVENT_HANDLED);
        }
    },

};

export default EventListener;